import { getPageAnalytics } from '@ynap/analytics'

export function getConfig(state) {
    return {
        config: state.config,
        locale: state.locale,
        deviceType: state.deviceType,
    }
}

export function myaccountPageData({ name, subCategory1 }) {
    return function (props) {
        if (typeof window !== 'undefined') {
            const { locale, config, deviceType } = props

            const business = (config.business || config.head.business).toLowerCase()

            const pageAnalytics = {
                business,
                region: locale.region,
                currency: locale.currency,
                pageName: `my account - ${name}`,
                pageType: 'account management',
                featuresList: [],
                primaryCategory: 'my account',
                subCategory1: subCategory1,
                location: window.location,
                language: locale.language,
                country: locale.country,
                deviceType,
            }

            return {
                ...getPageAnalytics(pageAnalytics),
            }
        }
    }
}

export function trackTermsAndPrivacyAnalytics(item) {
    const secondLevelCategories = {
        primaryCategory: 'my account',
        subCategory: 'privacy settings',
    }
    if (item.key === 'consent-terms') {
        return {
            event: 'read terms and conditions',
            effect: 'terms and conditions',
            category: secondLevelCategories,
        }
    } else if (item.key === 'consent-privacy') {
        return {
            event: 'read privacy policy',
            effect: 'privacy policy',
            category: secondLevelCategories,
        }
    }
}
// TODO: investigate a longer term solution to not use teaserTitle here for the external links

export function trackDataRequestsAnalytics(props) {
    const event = props.teaserTitle.toLowerCase()
    const effect = 'customer data request'
    const secondLevelCategories = {
        primaryCategory: 'my account',
        subCategory: 'privacy settings',
    }

    if (['access', 'change', 'delete'].includes(event)) {
        return {
            event: event,
            effect: effect,
            category: secondLevelCategories,
        }
    }
}

export function trackAccountNavigationClick(section) {
    return {
        event: `my account navigation - ${section}`,
        effect: 'open my account page',
        category: {
            primaryCategory: 'my account',
            subCategory: section,
        },
    }
}

export function getPrice(price) {
    return price ? Number(price.replace(/[^0-9.]+/g, '')) : 0
}

export const getItem = ({ item, attributes }) => {
    const { analytics = {}, price, quantity } = item
    const { name, brand, brandId, productID, masterCategory } = analytics

    return {
        productInfo: {
            productID,
            name,
            designer: brand,
            designerID: brandId,
        },
        category: {
            primaryCategory: masterCategory?.labelEN || masterCategory?.label,
            subCategory1: masterCategory?.child?.labelEN || masterCategory?.child?.label,
            subCategory2: masterCategory?.child?.child?.labelEN || masterCategory?.child?.child?.label,
        },
        price: {
            currency: price?.currency?.label,
            baseFullPrice: getPrice(price?.originalPrice || price?.orderItemPrice),
            basePrice: getPrice(price?.orderItemPrice),
            basePriceGBP: undefined,
        },
        quantity,
        ...(attributes && { attributes }),
    }
}

export const trackOpenDeleteModal = () => {
    return {
        event: 'open account deletion',
        effect: 'click on close account button',
        category: {
            primaryCategory: 'my account',
            subCategory: 'privacy settings',
        },
    }
}

export const trackClickDelete = () => {
    return {
        event: 'confirm account deletion',
        effect: 'submit the account deletion',
        category: {
            primaryCategory: 'my account',
            subCategory: 'privacy settings',
        },
    }
}

export const trackCancelDelete = () => {
    return {
        event: 'cancel account deletion',
        effect: 'click on cancel button',
        category: {
            primaryCategory: 'my account',
            subCategory: 'privacy settings',
        },
    }
}

export const trackRewardsPageUpdates = (action, message) => {
    return {
        event: `${action}_loyalty_rewards_page_tier_updates`,
        content: message,
    }
}
